import request from '@/utils/request'


// 查询球场订单列表
export function listOrder(query) {
  return request({
    url: '/golf/golf-order/list',
    method: 'get',
    params: query
  })
}

/** 按用户查询球场订单列表 */
export function getUserOrderList(query) {
  return request({
    url: '/golf/golf-order/getUserOrderList',
    method: 'get',
    params: query
  })
}

// 查询球场订单分页
export function pageOrder(query) {
  return request({
    url: '/golf/golf-order/page',
    method: 'get',
    params: query
  })
}

// 查询球场订单详细
export function getOrder(data) {
  return request({
    url: '/golf/golf-order/detail',
    method: 'get',
    params: data
  })
}

// 新增球场订单
export function addOrder(data) {
  return request({
    url: '/golf/golf-order/add',
    method: 'post',
    data: data
  })
}

// 修改球场订单
export function updateOrder(data) {
  return request({
    url: '/golf/golf-order/edit',
    method: 'post',
    data: data
  })
}

// 删除球场订单
export function delOrder(data) {
  return request({
    url: '/golf/golf-order/delete',
    method: 'post',
    data: data
  })
}
